import React from "react";
import styled from "styled-components";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Carousel = ({ slides, maxWidth = 780, initialSlide = 0 }) => {
  const [currentSlide, setCurrentSlide] = React.useState(initialSlide);

  const handleNextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handleBackSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };
  return (
    <>
      <CarouselContainer maxWidth={maxWidth}>
        <CarouselContent
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <CarouselSlide key={index}>{slide}</CarouselSlide>
          ))}
        </CarouselContent>
      </CarouselContainer>
      <CarouselController>
        <ControlIcon onClick={handleBackSlide}>
          <ArrowBackIosNewIcon
            style={{
              fontSize: "18px",
            }}
          />
        </ControlIcon>
        <SlideIndicator>
          {currentSlide + 1}/{slides.length}
        </SlideIndicator>
        <ControlIcon onClick={handleNextSlide}>
          <ArrowForwardIosIcon
            style={{
              fontSize: "18px",
            }}
          />
        </ControlIcon>
      </CarouselController>
    </>
  );
};

export default Carousel;

export const CarouselContainer = styled.div`
  width: 100%; /* Adjust as needed */
  max-width: ${(props) => props.maxWidth}px;
  overflow: hidden;
  position: relative;
  margin: auto;
`;

export const CarouselContent = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
`;

export const CarouselSlide = styled.div`
  flex: 0 0 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CarouselController = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  border: 1px solid #e8e8e8;
  width: max-content;
  border-radius: 1000px;
  margin-left: auto;
  margin-right: auto;
`;

export const ControlIcon = styled.div`
  cursor: pointer;
  display: grid;
  place-items: center;
  padding: 5px 15px;
`;

export const SlideIndicator = styled.div`
  display: grid;
  place-items: center;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  padding: 8px 15px;
  font-size: 18px !important;
  line-height: 24px;
`;
